module.exports = __webpack_public_path__ + "static/fonts/PingFang Heavy.1c97d8de.ttf";